import { HttpClient, HttpParams, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Audit } from './audit.model';

@Injectable()
export class AuditsService {
    constructor(private http: HttpClient) { }

    query(req: any): Observable<HttpResponse<Audit[]>> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('fromDate', req.fromDate);
        params.set('toDate', req.toDate);
        params.set('page', req.page);
        params.set('size', req.size);
        params.set('sort', req.sort);

        let options = this.createRequestOption(req);

        return this.http.get<HttpResponse<Audit[]>>('management/audits', options);
    }

    private createRequestOption(req?: any): {} {
        let httpParams: HttpParams = new HttpParams();
        if (req) {
            if (req.page) {
                httpParams = httpParams.set('page', req.page);
            }
            if (req.size) {
                httpParams = httpParams.set('size', req.size);
            }

            if (req.sort) {
                httpParams = httpParams.set('sort', req.sort);
            }

            if (req.fromDate) {
                httpParams = httpParams.set('fromDate', req.fromDate);
            }
            if (req.toDate) {
                httpParams = httpParams.set('toDate', req.toDate);
            }
        }

        let httpHeaders: HttpHeaders = new HttpHeaders();
        return {headers: httpHeaders, params : httpParams, observe: 'response'};
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/audits/audits.service.ts